import { encryptObject } from "@/helpers/noncehelper";
import {
  addMealPlan,
  deleteMealPlan,
  getMealPlanRecipes,
  updateMealPlan,
} from "@/services/mealplan";
import { fetchSafeJson } from "@/utils/apiResponse";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const addMealPlanAction = createAsyncThunk(
  "/mealplan/create",
  async (payload: any) => {
    try {
      const res = await addMealPlan(encryptObject(payload));
      return res;
    } catch (error) {
      console.log(error);
    }
  }
);

export const getMealPlanRecipesAction = createAsyncThunk(
  "/mealplan",
  async ({
    start_date,
    end_date,
    recipe_id,
    token,
  }: {
    start_date: string;
    end_date: string;
    recipe_id?: string | number;
    token: string;
  }) => {
    try {
      const res = await getMealPlanRecipes(
        encryptObject({
          start_date,
          end_date,
          recipe_id,
          token,
        })
      );

      const data: any = await fetchSafeJson(res);
      return data?.response;
    } catch (error) {
      console.log(error);
    }
  }
);

export const updateMealPlanAction = createAsyncThunk(
  "/mealplan",
  async (payload: any) => {
    try {
      const res = await updateMealPlan(encryptObject(payload));
      return res;
    } catch (error) {
      console.log(error);
    }
  }
);
export const deleteMealPlanAction = createAsyncThunk(
  "/mealplan/delete",
  async (payload: any) => {
    try {
      const res = await deleteMealPlan(payload);
      return res;
    } catch (error) {
      console.log(error);
    }
  }
);
